var map = {
	"./1.png": "3od+",
	"./10.png": "G+jg",
	"./2.png": "WjQi",
	"./3.png": "KzkN",
	"./4.png": "8No7",
	"./5.png": "2y4c",
	"./6.png": "86DN",
	"./7.png": "qnd0",
	"./8.png": "d7Oc",
	"./9.png": "bRxF",
	"./bg.png": "z3Wb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NTig";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4 nonrecursive \.png$/
// module id = NTig
// module chunks = 2